import { render, staticRenderFns } from "./AnswerInput.vue?vue&type=template&id=a95a2256&scoped=true&"
import script from "./AnswerInput.vue?vue&type=script&lang=js&"
export * from "./AnswerInput.vue?vue&type=script&lang=js&"
import style0 from "./AnswerInput.vue?vue&type=style&index=0&id=a95a2256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95a2256",
  null
  
)

export default component.exports